import MandatoryLabel from "@/app/components/ui/Reusable/MandatoryLabel";
import SearchableMultiSelectMenu from "@/app/components/ui/SelectMenus/MultiSelectMenu";
import { ISelectMenuItemData, SelectMenuItems } from "@/app/components/ui/interface";
import SurgeryOptionCard, { ISurgeryCardOption } from "./SurgeryOptionCard";

export interface ISurgerySectionCard {
  option: ISurgeryCardOption;
  price: number;
  originalPrice: number;
  discountPercent: number;
  selectedCouponId?: string;
}

interface ISurgerySectionProps {
  surgeryItems: SelectMenuItems;
  defaultSelected: ISelectMenuItemData[];
  isOptionsLoading: boolean;
  onSelectSurgeries: (items: ISelectMenuItemData[]) => void;
  onRemoveSurgery: (surgeryId: string) => void;
  isCardLoading: boolean;
  surgeryCards: ISurgerySectionCard[];
  formatAmount: (amount: number) => string;
  onSelectCoupon: (
    surgeryId: string,
    couponId: string | null | undefined,
    couponName: string | null | undefined,
  ) => void;
}

const SurgerySection: React.FC<ISurgerySectionProps> = ({
  surgeryItems,
  defaultSelected,
  isOptionsLoading,
  onSelectSurgeries,
  onRemoveSurgery,
  isCardLoading,
  surgeryCards,
  formatAmount,
  onSelectCoupon,
}) => {
  return (
    <>
      <div className="grid grid-cols-1 gap-3 lg:grid-cols-[180px_minmax(0,1fr)] lg:items-center">
        <div className="text-[14px] font-semibold text-[#222222]">
          <MandatoryLabel label={"Surgery Items"} isMandatory={true} />
          <p className="mt-0.5 text-[11px] font-normal text-[#6C727F]">Select at least 1</p>
        </div>
        <div>
          <SearchableMultiSelectMenu
            errorMessages={[]}
            onSelectItem={(items) => onSelectSurgeries(items ?? [])}
            fieldError={undefined}
            register={{} as any}
            selectItems={surgeryItems}
            placeholder="Select Surgery Items"
            showTooltips={true}
            showTypedErrors={false}
            showDropdownIcon={true}
            listZIndex="z-20"
            showDropdownWhenNoData={true}
            noDataDropDownContent={
              isOptionsLoading ? (
                <span className="text-center text-[10px] sm:text-xs">Loading surgeries...</span>
              ) : (
                <span className="text-center text-[10px] sm:text-xs">No surgeries found</span>
              )
            }
            defaultSelected={defaultSelected}
            className="text-[12px] font-medium text-[#3B4250] placeholder:text-[12px] placeholder:font-medium placeholder:text-[#6C727F]"
            containerClassName="w-full"
          />
        </div>
      </div>

      {surgeryCards.map((card) => (
        <SurgeryOptionCard
          key={card.option.id}
          isLoading={isCardLoading}
          surgeryOption={card.option}
          surgeryPrice={card.price}
          surgeryOriginalPrice={card.originalPrice}
          surgeryDiscountPercent={card.discountPercent}
          isSelected={true}
          formatAmount={formatAmount}
          onAdd={() => undefined}
          onRemove={() => onRemoveSurgery(card.option.id)}
          selectedCouponId={card.selectedCouponId}
          onSelectCoupon={(couponId, couponName) => onSelectCoupon(card.option.id, couponId, couponName)}
        />
      ))}
    </>
  );
};

export default SurgerySection;
